<template>
  <div :class="$style.container">
    <a
      :href="accountUrl"
      :class="$style.accountLink"
    >
      <img
        src="~@images/dd-arrow.svg"
        width="13"
        height="9"
        :class="$style.accountLinkImg"
      >
      <span
        v-translate
        :class="$style.accountLinkText"
      >accountLink</span>
    </a>
  </div>
</template>

<script>
  import LocaleCollection from '@models/Locale/collection'

  export default {
    props: {
      accountUrl: {
        type: String
      },
      locales: {
        type: LocaleCollection,
        required: true
      }
    },
    locales: {
      'en': {
        'accountLink': 'Back to account'
      },
      'ru': {
        'accountLink': 'Назад к счёту'
      }
    }
  }
</script>

<style lang="scss" module>

  /**
   * Container
   */
  .container {
    display: flex;
    align-items: center;
  }

   /**
   * Account link button
   */
  .accountLink {
    display: block;
    position: relative;
    height: 46px;
    line-height: 44px;
    border-radius: 23px;
    box-shadow: 0px 2px 13px 0 rgba(85, 107, 130, 0.15);
    padding: 0 24px 0 30px;
    text-decoration: none;
    margin-left: 30px;
  }

  /**
   * Account link buttom image
   */
  .accountLinkImg {
    transform: rotate(90deg);
    opacity: .7;
    margin-top: 9px;
  }

  /**
   * Account link button text
   */
  .accountLinkText {
    color: #3e566f;
    font-size: 15px;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccountLink.vue